import React from "react";
import { countProductSelectionKey, uniqueCountProducts } from "../utils/mcCountProductScope";

export default function McCountProductPicker({ rows = [], selectedIds = [], onSelectionChange, search = "", onSearchChange }) {
  const selected = new Set(selectedIds);
  const choices = uniqueCountProducts(rows);
  const needle = String(search || "").trim().toLowerCase();
  const visibleRows = needle ? choices.filter((row) => [row.product, row.sku, row.category].some((value) => String(value || "").toLowerCase().includes(needle))) : choices;
  const selectedRows = choices.filter((row) => selected.has(countProductSelectionKey(row)));

  return (
    <>
      <details>
        <summary>
          {selectedIds.length ? `${selectedIds.length} product${selectedIds.length === 1 ? "" : "s"} selected` : "All products"}
        </summary>
        <div className="mc-countPreparation__menu mc-countPreparation__productMenu">
          <div className="mc-countPreparation__productSearch">
            <input type="search" value={search} onChange={(event) => onSearchChange(event.target.value)} placeholder="Search product or SKU" aria-label="Search products for this count" />
          </div>
          <button type="button" onClick={() => onSelectionChange([])}>All products</button>
          {visibleRows.map((row) => {
            const rowKey = countProductSelectionKey(row);
            const checked = selected.has(rowKey);
            return (
              <label key={rowKey} className={`mc-countPreparation__productChoice${checked ? " is-selected" : ""}`}>
                <input
                  type="checkbox"
                  className="mc-countPreparation__choiceInput"
                  checked={checked}
                  onChange={(event) => {
                    const shouldSelect = event.target.checked;
                    onSelectionChange((current) => shouldSelect
                      ? Array.from(new Set([...current, rowKey]))
                      : current.filter((id) => id !== rowKey));
                  }}
                />
                <span className="mc-countPreparation__choiceMark" aria-hidden="true">
                  {checked ? <svg viewBox="0 0 20 20" focusable="false"><path d="m4 10 4 4 8-8" /></svg> : null}
                </span>
                <span className="mc-countPreparation__productOption">
                  <strong>{row.product || "Unnamed product"}</strong>
                  <small>{row.sku || "No SKU"}</small>
                </span>
                {checked ? <span className="mc-countPreparation__selectedBadge" aria-hidden="true">Selected</span> : null}
              </label>
            );
          })}
          {!visibleRows.length ? <div className="mc-countPreparation__empty">No matching products</div> : null}
        </div>
      </details>
      {selectedRows.length ? (
        <div className="mc-countPreparation__selectionRecap" aria-live="polite" aria-atomic="true">
          {selectedRows.slice(0, 3).map((row) => <span key={countProductSelectionKey(row)}>{row.product || row.sku || "Unnamed product"}</span>)}
          {selectedRows.length > 3 ? <small>+{selectedRows.length - 3} more selected</small> : null}
        </div>
      ) : null}
    </>
  );
}
